import { FastField } from 'formik';
import KTFormGroup from 'general/components/OtherKeenComponents/Forms/KTFormGroup';
import KTFormInput, { KTFormInputType } from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import AppColors from 'general/constants/AppColors';
import { useTranslation } from 'react-i18next';
import { Row, Col, Modal } from 'react-bootstrap';
import UIHelper from 'general/helpers/UIHelper';

function LandlordCommissionView({
    formikProps,
    isLandlordCommissionOn,
    handleToggle,
}) {
    const { t } = useTranslation();

    return (
        <Row>
            <Col md={12}>
                <Modal.Title className="mb-3 d-flex gap-2 align-items-center">
                    <span
                        className="font-weight-bolder"
                        style={{
                            fontSize: 18,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('Hoa hồng giới thiệu mặt bằng')}
                    </span>
                    {UIHelper.buildToggleSwitch(isLandlordCommissionOn, handleToggle)}
                </Modal.Title>
                <div style={UIHelper.buildFontStyle('500', '13px', AppColors.gray[800])}>
                    Mức hoa hồng được quy định và áp dụng riêng theo từng loại mặt bằng.
                </div>
            </Col>
            {/* {formikProps.values.landlordCommission?.map((discount, index) => (
                <div key={index + 1}>
                    <Row>
                        <Col md={7} className="pr-0" style={{ paddingLeft: 15 }}>
                            <KTFormGroup
                                label={
                                    <span
                                        className="font-weight-boldest"
                                        style={{
                                            fontSize: 13,
                                            color: AppColors.gray[800],
                                        }}
                                    >
                                        {t('Loại mặt bằng')}{' '}
                                    </span>
                                }
                                inputName={`landlordCommission[${index}].name`}
                                additionalClassName="mb-3"
                                inputElement={
                                    <FastField name={`landlordCommission[${index}].name`}>
                                        {({ field, form, meta }) => {
                                            return (
                                                <KTFormInput
                                                    name={field.name}
                                                    value={field.value}
                                                    onChange={(value) => {
                                                        form.setFieldValue(field.name, value);
                                                    }}
                                                    onBlur={() => {
                                                        form.setFieldTouched(field.name, true);
                                                    }}
                                                    enableCheckValid
                                                    type={KTFormInputType.text}
                                                    placeholder={'Nhập số'}
                                                    isValid={_.isEmpty(meta.error)}
                                                    isTouched={meta.touched}
                                                    feedbackText={meta.error}
                                                    disabled={true}
                                                />
                                            );
                                        }}
                                    </FastField>
                                }
                            // isRequired={true}
                            />
                        </Col>

                        <Col md={5} className="pr-5">
                            <KTFormGroup
                                label={
                                    <span
                                        className="font-weight-boldest"
                                        style={{
                                            fontSize: 13,
                                            color: AppColors.gray[800],
                                        }}
                                    >
                                        {t('Mức hoa hồng')}
                                    </span>
                                }
                                inputName={`landlordCommission[${index}].value`}
                                additionalClassName=" mb-3"
                                inputElement={
                                    <FastField name={`landlordCommission[${index}].value`}>
                                        {({ field, form, meta }) => {
                                            return (
                                                <KTFormInput
                                                    name={field.name}
                                                    value={field.value}
                                                    onChange={(value) => {
                                                        form.setFieldValue(field.name, value);
                                                    }}
                                                    onBlur={() => {
                                                        form.setFieldTouched(field.name, true);
                                                    }}
                                                    enableCheckValid
                                                    type={KTFormInputType.currency}
                                                    placeholder={'Nhập số'}
                                                    isValid={_.isEmpty(meta.error)}
                                                    isTouched={meta.touched}
                                                    feedbackText={meta.error}
                                                    disabled={true}
                                                />
                                            );
                                        }}
                                    </FastField>
                                }
                            // isRequired={true}
                            />
                        </Col>
                    </Row>
                </div>
            ))} */}
        </Row>
    )
}

export default LandlordCommissionView;